module.exports = __webpack_public_path__ + "static/media/xero.66abb5cc.svg";